// Permission NAME → user-facing display label.
//
// Permission rows are identified by their backend name strings (role bindings
// use permissionID; `can('View Paths')` checks stay unchanged). Only the
// DISPLAY label changes during the Paths → Automations rename (contract
// "stable identity during transition" — names stay until the P10 cutover).
// Unknown names pass through unchanged.

const PERMISSION_DISPLAY_LABELS = {
    'View Paths': 'View Automations',
    'Create Paths': 'Create Automations',
    'Update Paths': 'Update Automations',
    'Delete Paths': 'Delete Automations',
    'Enroll People in Paths': 'Run Automations',
};

export const getPermissionDisplayLabel = (name) =>
    PERMISSION_DISPLAY_LABELS[name] || name;

// Permission module (Permissions.module) → display label. Module strings are
// backend data; only the rendered name changes.
export const PERMISSION_MODULE_LABELS = {
    Paths: 'Automations',
};

export { PERMISSION_DISPLAY_LABELS };
